import { createAsyncThunk } from '@reduxjs/toolkit';

import { StatementService } from 'api';

import { StatementData } from 'models';

export const getDepositWithdrawal = createAsyncThunk(
	'statement/getDepositWithdrawal',
	async (data: StatementData) => {
		return await StatementService.getDepositWithdrawal(data);
	},
);
